import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35c4679e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "role" }
const _hoisted_2 = { class: "menu-tree" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      formConfig: _ctx.formConfig,
      onResetBtnClick: _ctx.resetBtnClick,
      onQueryBtnClick: _ctx.queryBtnClick
    }, null, 8, ["formConfig", "onResetBtnClick", "onQueryBtnClick"]),
    _createVNode(_component_PageContent, {
      ref: "pageContentRef",
      contentConfig: _ctx.contentConfig,
      pageName: "role",
      onEditBtnClick: _ctx.editBtnClick,
      onNewBtnClick: _ctx.newBtnClick
    }, null, 8, ["contentConfig", "onEditBtnClick", "onNewBtnClick"]),
    _createVNode(_component_PageModal, {
      ref: "pageModalRef",
      pageName: "role",
      modalConfig: _ctx.roleModalConfig,
      otherInfo: _ctx.otherInfo
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_tree, {
            ref: "elTreeRef",
            data: _ctx.menus,
            "show-checkbox": "",
            "node-key": "id",
            props: { children: 'children', label: 'name' },
            onCheck: _ctx.handleCheckChange
          }, null, 8, ["data", "onCheck"])
        ])
      ]),
      _: 1
    }, 8, ["modalConfig", "otherInfo"])
  ]))
}